import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
// Bootstrap removed - using Tailwind-only approach
import { ArrowLeft } from "lucide-react";
import ContainerWrapper from "../components/containerwrapper.jsx";
import LeadJourneyContainerWrapper from "../components/lead-journey/LeadJourneyContainerWrapper.jsx";
import { useUserContext } from "../context/UserContext";
import PageHeader from "../components/pageHeader.jsx";

export default function LeadJourney() {
  const { setLeadId } = useUserContext();
  const { setUserId } = useUserContext();
  const { leadId } = useUserContext();
  const [leadID, setLeadID] = useState("")
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [buttonText, setButtonText] = useState("Click Me");

  useEffect(() => {
    const queryString = window.location.search;
    const queryParams = new URLSearchParams(queryString);
    setLeadId(queryParams.get("lead_id") || "No lead ID found");
    // use query params instead of user context lead id
    setLeadID(queryParams.get("lead_id") || "No lead ID found");
  }, []);

  return (
    <>
      <LeadJourneyContainerWrapper leadID={leadID} />
    </>
  );
}
